import { FC, SVGProps } from 'react'

export const CloseIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_122_515" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_122_515)">
        <path
          d="M6.062 15L5 13.938L8.938 10L5 6.062L6.062 5L10 8.938L13.938 5L15 6.062L11.062 10L15 13.938L13.938 15L10 11.062L6.062 15Z"
          fill="#14151A"
        />
      </g>
    </svg>
  )
}
